import { useParams } from 'react-router-dom'
import { MultiplyDetailSection } from '@/components/dashboard/MultiplyDetailSection'

export function MultiplyDetailPage() {
  const { id } = useParams()
  return (
    <div style={{ maxWidth: 1240, margin: '0 auto', padding: '24px' }}>
      <MultiplyDetailSection id={id} />
    </div>
  )
}
